module.exports = __webpack_public_path__ + "img/05.56d3bf79.png";